import React from "react";
import { Input } from "@/components/ui/input";

interface DurationCostStepProps {
  id: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  prefix?: string;
  suffix?: string;
  placeholder?: string;
}

const DurationCostStep: React.FC<DurationCostStepProps> = ({
  id,
  value,
  onChange,
  onKeyDown,
  prefix,
  suffix,
  placeholder,
}) => {
  return (
    <div className="relative">
      {prefix && (
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-500 text-[13px]">
          {prefix}
        </span>
      )}
      <Input
        name={id}
        type="text"
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        className={`w-full text-sm font-light leading-relaxed focus-visible:outline-none focus-visible:ring-0 rounded-lg
          ${prefix ? "pl-7" : ""}
          ${suffix ? "pr-14" : ""}`}
      />
      {suffix && (
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-neutral-500 text-[13px]">
          {suffix}
        </span>
      )}
    </div>
  );
};

export default DurationCostStep;
